import {ActionComponent, ActionComponentScope} from "../action.component";
import {OpportunityAction} from "../../../model/OpportunityAction";
import {IHttpPromise, IPromise} from "angular";
import {ActionStatus} from "../../../../action_status/model/ActionStatus";

export interface EmailActionScope extends ActionComponentScope {

}

export abstract class EmailActionComponent extends ActionComponent {

    protected $scope: EmailActionScope;

    protected executeAction: () =>
        IPromise<angular.IHttpResponse<OpportunityAction[]>> = () => this.sendEmail();

    sendEmail = (): IHttpPromise<OpportunityAction[]> => {
        let opportunity = this.$scope.opportunity;
        return this.actionService.sendActionRequest(opportunity.id, {
            actionType: this.getActionType(),
            customerId: opportunity.customer.id,
            calculatorId: opportunity.calculator.id,
            calculationExecutionLogId: opportunity.id,
            status: ActionStatus.NEW
        });
    };


}